import { CorpoTable, Tabela, TabelaCabeca, TabelaCorpo, Tabler } from "../../../../../components/formulario/tableStyled";
import { CircularProgress } from "@mui/material";
import { SecaoButao, Container } from "../../../../../components/formulario/styled";
import { useEffect, useState, useRef } from 'react';
import api from "../../../../../utils/api";
import OpenExcelUniversal from "../../../../../components/excel/OpenExcelUniversal";
import DonwloadPdf from "../../../../../components/pdf/DonwloadPdf";
import SearchInput from "../../../../../components/inputs/searchInput";
import ModalExportar from "../../../../../components/modalExportar";

export default function TabelaMembrosSemPg() {

  const [loading, setLoading] = useState(false);
  const [filas, setFilas] = useState<any>({ fila: 0, tamanho: 300 });
  const [dado, setDado] = useState<any[]>([]);
  const [pesquisarPorNome, setPesquisarPorNome] = useState('');


  const getUsuarios = () => {
    setLoading(true);
    api.get('view/usuario/sempg')
      .then(res => {
        setDado(res.data);
        setLoading(false)
      }
      )
      .catch(
        erro => {
          setLoading(false);
        }
      )
  }

  useEffect(() => {
    getUsuarios();
  }, []);

  const devRef = useRef<HTMLElement>(null);

  const Td = () => <>
    {
      dado.filter(element =>
        String(
          element?.['nome']).toLocaleLowerCase().normalize('NFD')
          .replace(/[\u0300-\u036f]/g, "")
          .match(
            pesquisarPorNome.toLocaleLowerCase().normalize('NFD')
              .replace(/[\u0300-\u036f]/g, "")
          )
      ).splice(0, (filas.fila + 1) * 30).map(
        elem =>
          <tr>
            <td>{elem?.['nome']}</td>
            <td>{elem?.['telefone']}</td>
            <td>{elem?.['email']}</td>
            <td>{elem?.['descricao']}</td>
            <td>{elem?.['batizado']}</td>
            <td>{elem?.['bairro']}</td>
          </tr>
      )
    }
  </>

  useEffect(() => {
    if (devRef.current) {
      devRef.current.addEventListener('scroll', (e: any) => {
        if (e.target?.scrollTop >= (e.target.scrollHeight - (e.target.clientHeight + 60))) {
          setFilas({ fila: filas.fila++, tamanho: filas.tamanho + 300 })
        }
      })
    }
  }, [devRef]);

  return (
    <>
      <div style={{ display: "flex", flex: 1, padding: 5 }}>
        <Container>
          <SecaoButao style={{ marginBottom: 5 }}>
            <section style={{ display: 'flex', gap: 5 }}>

              <ModalExportar
                callDownloadExcel={() => OpenExcelUniversal(dado, ["nome", "telefone", "email", "descricao", "batizado", "bairro"])}
                callDownloadPdf={() => DonwloadPdf(dado, ["Nome", "Telefone", "E-mail", "Cidade", "Batizado", "Bairro"],
                  ["nome", "telefone", "email", "descricao", "batizado", "bairro"], dado?.length, [], `${dado?.length}`)}
              />

            </section>
            <SearchInput
              placeholder="Procure por nome"
              onChange={(e) => setPesquisarPorNome(e.target.value.replace(/script/g, ""))}
            />
            <section />
          </SecaoButao>
          <Tabler>
            {/*@ts-ignore*/}
            <CorpoTable ref={devRef}>
              {
                loading ?
                  <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    < CircularProgress />
                  </div>
                  :
                  <Tabela>
                    <>
                      <TabelaCabeca>
                        <tr>
                          <th>Nome</th>
                          <th>Telefone</th>
                          <th>E-mail</th>
                          <th>Cidade</th>
                          <th>Batizado</th>
                          <th>Bairro</th>
                        </tr>
                      </TabelaCabeca>
                      <TabelaCorpo >
                        <Td />
                      </TabelaCorpo>
                    </>
                  </Tabela>
              }
            </CorpoTable>
          </Tabler>
        </Container>
      </div>
    </>
  )
}
